const IDENTITY_URL = process.env.REACT_APP_IDENTITY_URL || process.env.NEXT_PUBLIC_IDENTITY_URL || "";
const IDENTITY_API_URL = IDENTITY_URL + "/api";

const ASSET_API_URL = process.env.REACT_APP_ASSET_API_URL || process.env.NEXT_PUBLIC_ASSET_API_URL || "";
const COMMON_API_URL = process.env.REACT_APP_COMMON_API_URL || process.env.NEXT_PUBLIC_COMMON_API_URL || "";

export {
    IDENTITY_URL,
    IDENTITY_API_URL,

    ASSET_API_URL,
    COMMON_API_URL,
};

export const Constants = {
    Api: {
        TIMEOUT: 60 * 1000,
    },

    Styles: {
        PRIMARY_COLOR: "#222224",
        SECONDARY_COLOR: "#7b809a",
    },

    DefaultLanguage: "vi",

    /**
     * Cloud Storage config
     */
    CloudStorage: {
        TEMP_FOLDER: "temp",
        AVATAR_FOLDER: "/avatar",
        ORGANIZATION_IMAGE_FOLDER: "org_image",
        EDITOR_CONTENT_FOLDER: "editor_content",
        IMAGE: "image",
    },

    RegExp: {
        NEW_EMAIL_ADDRESS: new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),

    },

    ResourceCode: {
        ROLE: "identity/role",
        GROUP: "identity/group",
        STAFF: "identity/staff",
        CODENAME: "identity/codename",
        ORGANIZATION: "identity/organization",
    },

    ApiPath: {
        COMMON: {
            CREATE_ADDRESS: "Address/Create",
            UPDATE_ADDRESS: "Address/Update",
            GET_ADDRESS_BY_IDS: "Address/GetByIds",
            GET_COUNTRIES: "AdministrativeDivision/GetAll",
            GET_CHILDREN: "AdministrativeDivision/GetListByParentId"
        },

        // ASSET
        ASSET: {
            GET_ASSET_INFO: "/GetAssetInfo",
            GET_MULTI_ASSET_INFO: "/GetMultiAssetInfo",
            GET_ASSET_ACCESS_URL: "/GetAccessUrl",
            GET_ASSET_DOWNLOAD_URL: "/GetDownloadUrl",
            GET_EXTERNAL_URL_IDS: "/GetExternalUrlIds",
            CREATE_URL_ASSET: "/CreateUrlAsset",
            SET_ACTIVE_BY_ID: "/SetActiveById",
            GET_M3U8_URL: "/GetM3u8Url",
            UPDATE_RESOURCE_CODE: "/UpdateAssetResourceCode",
            GET_ASSET_SECRET: "/GetAssetSecret",
        },

        // PROFILE
        PROFILE: {
            GET_USER_INFO: "/Profile/UserInfo",
            GET_USER_AUTHORIZATION: "/Profile/UserAuthorization",

            UPDATE_USER_PROFILE: "Profile/UpdateUserProfile",
            UPDATE_ORGANIZATION_PROFILE: "Profile/UpdateOrganizationProfile",

            CHANGE_EMAIL: "Profile/ChangeEmail",
            CHANGE_AVATAR: "Profile/ChangeAvatar",
            CHANGE_PASSWORD: "Profile/ChangePassword",
            CHANGE_PHONE_NUMBER: "Profile/ChangePhoneNumber",
            GET_CHANGE_EMAIL_OTP: "Profile/GetChangeEmailOTP",
            GET_CHANGE_PHONE_NUMBER_OTP: "Profile/GetChangePhoneNumberOTP",
        },

        // ROLE
        ROLE: {
            GET_ALL: "/Role/GetAll",
            GET_PAGED: "/Role/GetPaged",
            GET_DETAIL: "/Role/Detail",
            CREATE: "/Role/Create",
            UPDATE: "/Role/Update",
            DELETE: "/Role/Delete",
            UPDATE_STATUS: "/Role/UpdateStatus",
            COUNT_USER: "/Role/CountUser",
        },

        // SERVICE
        SERVICE: {
            GET_ALL: "/Service/GetAll",
            GET_PAGED: "/Service/GetPaged",
            GET_DETAIL: "/Service/Detail",
            CREATE: "/Service/Create",
            UPDATE: "/Service/Update",
            DELETE: "/Service/Delete",
            INIT_ROLE: "/Service/InitRole",
        },
        
        // POLICY
        POLICY: {
            GET_ALL: "/Policy/GetAll",
            GET_PAGED: "/Policy/GetPaged",
            GET_DETAIL: "/Policy/Detail",
            CREATE: "/Policy/Create",
            UPDATE: "/Policy/Update",
            DELETE: "/Policy/Delete",
        },

        // RESOURCE
        RESOURCE: {
            GET_ALL: "/Resource/GetAll",
            GET_TEMPLATE: "/Resource/GetTemplate",
            GET_PAGED: "/Resource/GetPaged",
            GET_DETAIL: "/Resource/Detail",
            CREATE: "/Resource/Create",
            UPDATE: "/Resource/Update",
            DELETE: "/Resource/Delete",
            INIT_DATA: "/Resource/InitData",
            GET_DEFAULT_RESOURCE_DETAIL: "/Resource/GetDefaultResourceDetail",
        },

        // ORGANIZATION
        ORGANIZATION: {
            GET_ALL: "/Organization/GetAll",
            GET_PAGED: "/Organization/GetPaged",
            GET_DETAIL: "/Organization/Detail",
            CREATE: "/Organization/Create",
            UPDATE: "/Organization/Update",
            DELETE: "/Organization/Delete",
            UPDATE_STATUS: "/Organization/UpdateStatus",
            OWNED_ORGANIZATION: "/Organization/OwnedOrganization",
        },

        // GROUP 
        GROUP: {
            GET_PAGED: "/Group/GetPaged",
            GET_ALL: "/Group/GetAll",
            GET_DETAIL: "/Group/Detail",
            CREATE: "/Group/Create",
            UPDATE: "/Group/Update",
            DELETE: "/Group/Delete",
            UPDATE_STATUS: "/Group/UpdateStatus",
        },

        // USER
        USER: {
            GET_PAGED: "/User/GetPaged",
            GET_SERVICE_USER_PAGED: "/User/GetServiceUserPaged",
            CREATE: "/User/Create",
            UPDATE: "/User/Update",
            DETAIL: "/User/Detail",
            DELETE: "/User/Delete",
            UPDATE_STATUS: "/User/UpdateStatus",
            GET_MANAGE_USER: "/User/GetManageUser",
        },

        // Codename
        CODENAME: {
            GET_BY_GROUP: "/Codename/GetByGroup",
            GET_PAGED: "/Codename/GetPaged",
            GET_DETAIL: "/Codename/Detail",
            DELETE: "/Codename/Delete",
            CREATE: "/Codename/Create",
            UPDATE: "/Codename/Update",
        },

        INVITATION: {
            CREATE: "/Invitation/Create",
            RESEND: "/Invitation/Resend",
            GET_ALL: "/Invitation/GetAll",
            GET_DETAIL: "/Invitation/Detail",
            GET_PAGED: "/Invitation/GetPaged",
            QUICK_INVITE: "/Invitation/QuickInvite",
            GET_PAGED_TENANT: "/Invitation/GetPagedTenant",
            DELETE: "/Invitation/Delete",
            ACCEPT: "/Invitation/Accept",
            DECLINE: "/Invitation/Decline",
        },

        USER_ROLE: {
            UPDATE: "/UserRole/Update",
        },

        GROUP_USER: {
            GET_DETAIL: "/GroupUser/GetDetail",
            CREATE: "/GroupUser/CreateGroupUser",
            UPDATE: "/GroupUser/UpdateGroupUser",
            DELETE: "/GroupUser/DeleteGroupUser",
        },

        USER_CONTACT: {
            GET_ALL_USER_CONTACT: "/UserContact/GetAll",
            GET_DEFAULT: "/UserContact/GetDefault",
            CREATE: "/UserContact/Create",
            UPDATE: "/UserContact/Update",
            DELETE: "/UserContact/Delete",
        },

        TWO_FACTOR_AUTH: {
            DETAIL: "/TwoFactorAuthentication/details",
            SETUP_AUTHENTICATOR: "/TwoFactorAuthentication/SetupAuthenticator",
            VERIFY_AUTHENTICATOR: "/TwoFactorAuthentication/VerifyAuthenticator",
            DISABLE_2FA: "TwoFactorAuthentication/Disable2FA",
            RESET_AUTHENTICATOR: "TwoFactorAuthentication/ResetAuthenticator",
        },

        // SERVICE_ORGANIZATION
        SERVICE_ORGANIZATION: {
            ADD: "/ServiceOrganization/Add",
        },

        WORKER_NODE: {
            GET_PAGED: "/WorkerNode/GetPaged",
            UPDATE: "/WorkerNode/Update",
        },



    },

    ROW_PER_PAGE: 20,
    ROW_PER_PAGE_OPTIONS: [20, 50, 100],

    UserRoleCode: {
        STUDENT: "000009",
        TUTOR: "00000A",
        ADMIN: "000030",
        OWNER: "00000B",
        MEMBER: "000032",
    },
};
